<form [formGroup]="form" (ngSubmit)="save()">
    <h1 mat-dialog-title>Cancelación de asignación del turno</h1>
    <div mat-dialog-content>
        <mat-form-field class="full-width">
            <mat-select formControlName="CancelledReservationReason" placeholder="Motivo de turno sín asignación" required>
                <mat-option *ngFor="let cancelledReservationReason of cancelledReservationReasons" [value]="cancelledReservationReason">
                    {{cancelledReservationReason.Name}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.CancelledReservationReason.errors && f.CancelledReservationReason.errors.required">
                Seleccione un motivo
            </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width">
            <textarea matInput placeholder="Observaciones"></textarea>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div class="pull-right">
            <button mat-button type="submit">Guardar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>